import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../utils/api';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const [step, setStep] = useState('email');        // 'email' | 'otp' | 'done'
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) return setError('Please enter your email.');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email.trim());
      setStep('otp');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    if (otp.length !== 6) return setError('Please enter the 6-digit OTP.');
    if (newPassword.length < 8) return setError('Password must be at least 8 characters.');
    if (newPassword !== confirmPassword) return setError('Passwords do not match.');
    setLoading(true);
    try {
      await authAPI.resetPassword(email.trim(), otp, newPassword);
      setStep('done');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (step === 'done') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Password Reset ✓</h2>
          <div className="success-message">
            Your password has been reset successfully. You can now log in with your new password.
          </div>
          <Link to="/login">
            <button type="button" style={{ width: '100%' }}>Go to Login</button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{step === 'email' ? 'Forgot Password' : 'Reset Password'}</h2>

        {error && <div className="error-message">{error}</div>}

        {step === 'email' && (
          <>
            <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px', fontSize: '14px' }}>
              Enter your registered email address. We'll send a 6-digit OTP to reset your password.
            </p>
            <form onSubmit={handleSendOTP}>
              <input
                type="email"
                placeholder="Registered email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Sending OTP...' : 'Send OTP'}
              </button>
            </form>
          </>
        )}

        {step === 'otp' && (
          <>
            <div className="success-message" style={{ marginBottom: '16px' }}>
              📧 If <strong>{email}</strong> is registered, an OTP has been sent to your inbox.
            </div>
            <form onSubmit={handleResetPassword}>
              <input
                type="text"
                placeholder="6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                maxLength={6}
                required
                autoFocus
                style={{ textAlign: 'center', letterSpacing: '0.5em', fontSize: '1.3em' }}
              />
              <input
                type="password"
                placeholder="New password (min 8 characters)"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={8}
              />
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
              <button
                type="button"
                onClick={() => { setStep('email'); setOtp(''); setNewPassword(''); setConfirmPassword(''); setError(''); }}
                style={{ marginTop: '8px', background: 'transparent', color: '#666', border: '1px solid #ddd' }}
              >
                ← Back
              </button>
            </form>
          </>
        )}

        <p><Link to="/login">Back to Login</Link></p>
      </div>
    </div>
  );
};

export default ForgotPassword;
